import styled from 'styled-components';
import { MediaQuery, Size } from '../../constant/breakpoint.ts';
import Select from 'react-select';


export const Wrapper = styled('div')({
    backgroundColor: "#EDEDED",
    paddingTop: '40px',
    paddingBottom: '40px',
})

export const Form = styled('div')({
    backgroundColor: 'white',
    width: '80%',
    margin: '0 auto',
    padding: '32px 64px 32px 64px',
    [MediaQuery[Size.LG]]: {
        width: '90%',
    },
    [MediaQuery[Size.MD]]: {
        padding: '32px 32px 32px 32px',
    },
})

export const FormTitle = styled('div')({
    fontWeight: '600',
    fontSize: '24px',
    color: '#CCA25E',
    fontFamily: "Gotham",
})

export const FormCaption = styled('div')({
    fontSize: '18px',
    lineHeight: 'auto',
    marginTop: '20px',
    fontWeight: '400',
    fontFamily: "Gotham"
})

export const FirstRow = styled('div')({

})

export const FlexRow = styled('div')({
    
})

export const Title = styled('div')({
    fontFamily: 'Roboto Flex',
})

export const FormArea = styled('div')({
    fontFamily: 'Roboto'
})

export const ContactYouAbout = styled('div')({
    marginTop: '48px',
    display: 'flex',
    flexDirection: 'column', 
    fontFamily: 'Roboto Flex',
})

export const NameContainer = styled('div')({
    display: 'flex',
    flexDirection: 'row',
    marginTop: '48px',
    fontSize: '12px',
    [MediaQuery[Size.MD]]: {
        flexDirection: 'column',
        marginTop: '48px',
    },
})

export const EmailContainer = styled('div')({
    display: 'flex',
    flexDirection: 'row',
    marginTop: '48px',
    fontSize: '12px',
    [MediaQuery[Size.MD]]: {
        flexDirection: 'column',
        marginTop: '48px',
    },
})

export const FieldContainer = styled('div')({
    width: '320px',
    fontSize: '12px',
    fontFamily: 'Roboto Flex',
})

export const CompanyContainer = styled('div')({
    width: '320px',
    fontSize: '12px',
    fontFamily: 'Roboto Flex',
    marginTop: '48px',
    [MediaQuery[Size.NAV]]: {
        width: '100%',
    },
})

export const FirstNameContainer = styled(FieldContainer)({
    [MediaQuery[Size.MD]]: {
        width: '100%',
    },
})

export const LastNameContainer = styled(FieldContainer)({
    marginLeft: '32px',
    
    [MediaQuery[Size.MD]]: {
        width: '100%',
        marginLeft: '0px',
        marginTop: '48px'
    },
})

export const EmailFieldContainer = styled(FieldContainer)({
    [MediaQuery[Size.MD]]: {
        width: '100%',
    },
})

export const PhoneContainer = styled(FieldContainer)({
    marginLeft: '32px',
    [MediaQuery[Size.MD]]: {
        width: '100%',
        marginLeft: '0px',
        marginTop: '48px'
    },
})

export const EmailBoxContainer = styled(FieldContainer)({
    width: '100%',
})

export const ContactYouInput = styled(Select)({
    width: '320px',
    
    [MediaQuery[Size.MD]]: {
        width: '90%',
    },
})

export const InputField = styled('input')({
    width: '302px',
    height: '62px',
    fontSize: '30px',
    marginTop: '8px',
    [MediaQuery[Size.LG]]: {
        width: '272px',
    },

    [MediaQuery[Size.MD]]: {
        width: '90%',
    },
})

export const RequiredFieldsText = styled('div')({
    fontSize: '10px',
    fontFamily: 'Roboto Flex',
    marginTop: '24px'
})

export const Line = styled('div')({
    display: 'block',
    height: '1px',
    border: '0',
    borderTop: '1px solid #000000',
    width: '100%',
})

export const SubmitButton = styled('div')({
    background: '#CCA25E',
    borderRadius: '45px',
    width: '219px',
    height: '56px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontFamily: "Gotham",
    fontSize: '26px',
    cursor: "pointer",
    [MediaQuery[Size.NAV]]: {
        marginTop: '24px',
        width: '172px',
        height: '42.6px',
        fontSize: '18px',
    },
})

export const LastRow = styled('div')({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: '48px',
    [MediaQuery[Size.LG]]: {
        width: '100%',
    },
    [MediaQuery[Size.MD]]: {
        flexDirection: 'column',
    },
})

export const LeftBox = styled('div')({
    width: '40%',

    [MediaQuery[Size.MD]]: {
        width: '100%'
    },
})